import { render } from "./AlterModal.vue?vue&type=template&id=10e0a61a"
import script from "./AlterModal.vue?vue&type=script&lang=js"
export * from "./AlterModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/precipitation/AlterModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10e0a61a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10e0a61a', __exports__)) {
    console.log('reload')
    api.reload('10e0a61a', __exports__)
  }
  
  module.hot.accept("./AlterModal.vue?vue&type=template&id=10e0a61a", () => {
    console.log('re-render')
    api.rerender('10e0a61a', render)
  })

}


export default __exports__